export interface ReferenceDefinitionDto {
    id: string;
    name: string;
    description?: string | null;
    relationshipType: string;
    relationshipDirection: RelationshipDirection;
    relatedElementFilter: ReferenceElementFilterDto;
    required: boolean;
    multiple: boolean;
    acl?: ReferenceDefinitionAclDto;
}

export interface ReferenceDefinitionAclDto {
    canUpdate: boolean;
    canDelete: boolean;
}

export enum RelationshipDirection {
    INCOMING = "INCOMING",
    OUTGOING = "OUTGOING",
}

export interface ReferenceElementFilterDto {
    type: string;
    stereotypeId?: string | null;
}

export interface ReferenceDefinitionCreateDto {
    name: string;
    description?: string | null;
    relationshipType: string;
    relationshipDirection: RelationshipDirection;
    relatedElementFilter: ReferenceElementFilterDto;
    required: boolean;
    multiple: boolean;
}

export interface ReferenceDefinitionUpdateDto {
    name: string;
    description?: string | null;
    relationshipType: string;
    relationshipDirection: RelationshipDirection;
    required: boolean;
    multiple: boolean;
}
